module.exports = __webpack_public_path__ + "img/054-snowy-1.ded49147.svg";